import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-size-input" }

import { type OtInputNumberState } from '@1trading/design-system';
import type { PropType } from 'vue';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import BigNumber from '@exchange/helpers/bignumber';
import numberFormat from '@exchange/helpers/number-format';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';
import type { MarketModel } from '@exchange/libs/market/service/src';
import { OrderSide } from '@exchange/libs/order/shared-model/src/lib/order-essentials';

type OrderSizeInputTooltip = {
  content: string;
  theme: string;
  shown: boolean;
  placement: string;
  distance: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderSizeInput',
  props: {
  amountTooltip: { type: Object as PropType<OrderSizeInputTooltip | null>, required: false },
  amountValue: { type: String as PropType<string | null> },
  autofocus: { type: Boolean, default: false },
  inputState: { type: String as PropType<OtInputNumberState>, default: 'default' },
  market: { type: Object as PropType<MarketModel>, required: true },
  orderSide: { type: String as PropType<OrderSide>, required: true },
  totalTooltip: { type: Object as PropType<OrderSizeInputTooltip | null>, required: false },
  totalValue: { type: String as PropType<string | null> },
},
  emits: ["input-focus", "input-blur", "update:totalValue", "update:amountValue"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { isXS } = useMQBreakpoints();
const { locale } = useI18n({ useScope: 'global' });
const isTotalShown = ref(false);

const asNumber = (value?: string): number => {
  if (!value) {
    return 0;
  }

  return new BigNumber(value).toNumber();
};

const formatSubtitle = (precision: number, currency: string, value?: string): string =>
  `${numberFormat({ number: asNumber(value), precision, locale: locale.value as string })} ${currency}`;

const formattedTotal = computed(() => formatSubtitle(props.market.marketPrecision, props.market.quote.code, props.totalValue));
const formattedAmount = computed(() => formatSubtitle(props.market.amountPrecision, props.market.base.code, props.amountValue));

const amountSubtitle = computed(() => (isXS.value ? formattedTotal.value : undefined));
const totalSubtitle = computed(() => (isXS.value ? formattedAmount.value : undefined));
const totalState = computed(() => (isXS.value ? props.inputState : 'default'));

const onSwitcherBtnClick = () => {
  isTotalShown.value = !isTotalShown.value;
};

const onUpdateTotal = ($event: string) => {
  emit('update:totalValue', $event);
};
const onUpdateAmount = ($event: string) => {
  emit('update:amountValue', $event);
};

const onInputFocus = ($event: FocusEvent) => {
  emit('input-focus', $event);
};
const onInputBlur = ($event: FocusEvent) => {
  emit('input-blur', $event);
};

return (_ctx: any,_cache: any) => {
  const _component_x_input_number = _resolveComponent("x-input-number")!
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_button = _resolveComponent("x-button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`order-size-input__${_unref(isXS) ? 'switcher' : 'joint-input'}`)
    }, [
      (!_unref(isXS) || !isTotalShown.value)
        ? _withDirectives((_openBlock(), _createBlock(_component_x_input_number, {
            key: 0,
            class: "order-size-input__amount",
            value: __props.amountValue,
            name: "amountValue",
            label: _ctx.$t('modules.orderForm.amount'),
            autofocus: __props.autofocus,
            state: __props.inputState,
            variant: "dark",
            compact: true,
            currency: __props.market.base.code,
            precision: __props.market.amountPrecision,
            subvalue: amountSubtitle.value,
            lpignore: true,
            onFocus: onInputFocus,
            onBlur: onInputBlur,
            "onUpdate:value": onUpdateAmount
          }, null, 8, ["value", "label", "autofocus", "state", "currency", "precision", "subvalue"])), [
            [_directive_tooltip, __props.amountTooltip]
          ])
        : _createCommentVNode("", true),
      (!_unref(isXS) || isTotalShown.value)
        ? _withDirectives((_openBlock(), _createBlock(_component_x_input_number, {
            key: 1,
            class: "order-size-input__total",
            value: __props.totalValue,
            name: "totalValue",
            label: _ctx.$t('modules.orderForm.total'),
            variant: "dark",
            compact: true,
            state: totalState.value,
            precision: __props.market.marketPrecision,
            currency: __props.market.quote.code,
            subvalue: totalSubtitle.value,
            lpignore: true,
            onFocus: onInputFocus,
            onBlur: onInputBlur,
            "onUpdate:value": onUpdateTotal
          }, null, 8, ["value", "label", "state", "precision", "currency", "subvalue"])), [
            [_directive_tooltip, __props.totalTooltip]
          ])
        : _createCommentVNode("", true),
      (_unref(isXS))
        ? (_openBlock(), _createBlock(_component_x_button, {
            key: 2,
            class: "order-size-input__switcher-button",
            onClick: onSwitcherBtnClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ot_icon, {
                class: "order-size-input__switcher-button-icon",
                name: "repeat"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})